var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 16 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { className: styles["burger-line-1"] || "burger-line-1", d: "M.875.875C.875.392 1.267 0 1.75 0h12.5a.875.875 0 0 1 0 1.75H1.75A.875.875 0 0 1 .875.875z", fill: "#DBDBDB" }),
    React.createElement("path", { className: styles["burger-line-2"] || "burger-line-2", d: "M.875 4.875c0-.483.392-.875.875-.875h12.5a.875.875 0 0 1 0 1.75H1.75a.875.875 0 0 1-.875-.875z", fill: "#DBDBDB" }),
    React.createElement("path", { className: styles["burger-line-3"] || "burger-line-3", d: "M.875 8.875c0-.483.392-.875.875-.875h12.5a.875.875 0 0 1 0 1.75H1.75a.875.875 0 0 1-.875-.875z", fill: "#DBDBDB" })
  );
});